export const attorneys = [
  {
    id: 1,
    name: 'Av. Mehmet Yılmaz',
    title: 'Kurucu Ortak',
    specialization: 'Kurumsal Hukuk & Ticari Dava',
    image: 'https://public.readdy.ai/ai/img_res/e5b3d131a2e62e746259d9ac63375370.jpg',
    education: 'İstanbul Üniversitesi Hukuk Fakültesi (2000), Harvard Law School LL.M. (2005)',
    experience: '25+ yıl hukuk pratiği',
    barMembership: 'İstanbul Barosu',
    languages: 'Türkçe, İngilizce, Almanca',
    practiceAreas: ['Kurumsal Hukuk', 'Ticari Dava', 'Uluslararası Ticaret Hukuku'],
    bio: 'Av. Mehmet Yılmaz, 25 yılı aşkın deneyimiyle Türkiye\'nin önde gelen kurumsal hukuk uzmanlarından biridir. Ulusal ve uluslararası şirketlere stratejik hukuki danışmanlık sunmakta, karmaşık ticari uyuşmazlıkların çözümünde öncü rol oynamaktadır. Harvard Law School\'da aldığı LL.M. derecesiyle uluslararası hukuk alanındaki uzmanlığını pekiştirmiş, çok sayıda yabancı yatırımcıya Türkiye\'deki hukuki süreçlerde rehberlik etmiştir.',
    achievements: [
      '500+ başarılı dava sonucu',
      'Chambers & Partners tarafından "Band 1" kategorisinde tanınma',
      'Legal 500 EMEA\'da önerilen avukat',
      '100+ uluslararası şirket danışmanlığı',
    ],
  },
  {
    id: 2,
    name: 'Av. Ayşe Demir',
    title: 'Kıdemli Ortak',
    specialization: 'Gayrimenkul & İnşaat Hukuku',
    image: 'https://readdy.ai/api/search-image?query=professional%20turkish%20female%20attorney%20in%20elegant%20navy%20business%20suit%20standing%20in%20modern%20law%20office%20with%20bookshelf%20background%20corporate%20headshot%20confident%20expression%20premium%20lighting%20sharp%20focus%20professional%20photography&width=400&height=500&seq=att2&orientation=portrait',
    education: 'Ankara Üniversitesi Hukuk Fakültesi (2003), London School of Economics LL.M. (2007)',
    experience: '22 yıl hukuk pratiği',
    barMembership: 'İstanbul Barosu',
    languages: 'Türkçe, İngilizce, Fransızca',
    practiceAreas: ['Gayrimenkul Hukuku', 'İnşaat Hukuku', 'Yatırım Hukuku'],
    bio: 'Av. Ayşe Demir, gayrimenkul ve inşaat hukuku alanında Türkiye\'nin en saygın uzmanlarından biridir. 22 yıllık kariyerinde, milyar dolarlık gayrimenkul projelerinin hukuki yapılandırılmasında danışmanlık vermiş, yabancı yatırımcıların Türkiye\'deki gayrimenkul yatırımlarında stratejik rehberlik sağlamıştır. LSE\'den aldığı LL.M. derecesiyle uluslararası yatırım hukuku konusundaki bilgisini derinleştirmiştir.',
    achievements: [
      '50+ büyük ölçekli gayrimenkul projesi danışmanlığı',
      'IFLR1000\'de tanınan gayrimenkul avukatı',
      '2 milyar USD+ değerinde işlem hacmi',
      'Türkiye Müteahhitler Birliği danışman avukatı',
    ],
  },
  {
    id: 3,
    name: 'Av. Can Özkan',
    title: 'Ortak Avukat',
    specialization: 'Sözleşme Hukuku & Uyuşmazlık Çözümü',
    image: 'https://readdy.ai/api/search-image?query=professional%20turkish%20male%20attorney%20in%20dark%20navy%20suit%20and%20tie%20standing%20in%20elegant%20law%20office%20with%20leather%20books%20background%20corporate%20headshot%20trustworthy%20expression%20premium%20lighting%20sharp%20focus%20professional%20photography&width=400&height=500&seq=att3&orientation=portrait',
    education: 'Boğaziçi Üniversitesi Hukuk Fakültesi (2008), Columbia Law School LL.M. (2012)',
    experience: '17 yıl hukuk pratiği',
    barMembership: 'İstanbul Barosu',
    languages: 'Türkçe, İngilizce',
    practiceAreas: ['Sözleşme Hukuku', 'Ticari Dava', 'Tahkim'],
    bio: 'Av. Can Özkan, sözleşme hukuku ve uyuşmazlık çözümü konusunda uzmanlaşmış, özellikle karmaşık ticari sözleşmelerin hazırlanması ve müzakeresinde derin deneyime sahiptir. Columbia Law School\'da aldığı eğitimle uluslararası tahkim süreçlerinde de aktif rol almakta, müvekkillerine stratejik çözümler sunmaktadır.',
    achievements: [
      '300+ sözleşme hazırlama ve müzakere',
      'ICC ve ISTAC tahkim davalarında temsil',
      'Başarı oranı %92',
      'Türkiye Ticaret Odası hukuk danışmanı',
    ],
  },
  {
    id: 4,
    name: 'Av. Zeynep Kaya',
    title: 'Kıdemli Avukat',
    specialization: 'Aile Hukuku & Ceza Hukuku',
    image: 'https://readdy.ai/api/search-image?query=professional%20turkish%20female%20attorney%20in%20sophisticated%20navy%20blazer%20standing%20in%20modern%20law%20office%20with%20city%20view%20background%20corporate%20headshot%20compassionate%20yet%20strong%20expression%20premium%20lighting%20sharp%20focus%20professional%20photography&width=400&height=500&seq=att4&orientation=portrait',
    education: 'Galatasaray Üniversitesi Hukuk Fakültesi (2010), Sorbonne Üniversitesi LL.M. (2013)',
    experience: '15 yıl hukuk pratiği',
    barMembership: 'İstanbul Barosu',
    languages: 'Türkçe, İngilizce, Fransızca',
    practiceAreas: ['Aile Hukuku', 'Ceza Hukuku', 'Miras Hukuku'],
    bio: 'Av. Zeynep Kaya, aile hukuku ve ceza hukuku alanlarında hassas ve stratejik yaklaşımıyla tanınmaktadır. 15 yıllık kariyerinde, yüksek profilli boşanma davalarından karmaşık ceza davalarına kadar geniş bir yelpazede müvekkillerine başarılı temsil sağlamıştır. Sorbonne\'da aldığı eğitimle Fransız hukuk sistemine de hakimdir.',
    achievements: [
      '250+ başarılı aile hukuku davası',
      'Yüksek profilli ceza davalarında savunma',
      'İstanbul Barosu Kadın Hakları Komisyonu üyesi',
      'Uluslararası aile hukuku uzmanı',
    ],
  },
];